import { render, staticRenderFns } from "./AllOrderLogistics.vue?vue&type=template&id=7db6fd66&"
import script from "./AllOrderLogistics.vue?vue&type=script&lang=js&"
export * from "./AllOrderLogistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports